// extracted by mini-css-extract-plugin
export var closeButton = "_f7-2";
export var closeButtonIcon = "_f7-3";
export var lightboxContent = "_f7-1";
export var lightboxOverlay = "_f7-0";